webpackJsonp([4],{

/***/ 100:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(55)(true);
// imports


// module
exports.push([module.i, ".video-block>div[data-v-bfd41fd6]{position:relative;height:0;padding-bottom:56.25%;overflow:hidden}.video-block>div iframe[data-v-bfd41fd6]{border:none}", "", {"version":3,"sources":["D:/Relocus/Dev/_Archive/Sota/sota/src/components/blocks/VideoBlock.vue"],"names":[],"mappings":"AACA,kCACE,kBAAmB,AACnB,SAAU,AACV,sBAAuB,AACvB,eAAiB,CAClB,AACD,yCACI,WAAa,CAChB","file":"VideoBlock.vue","sourcesContent":["\n.video-block > div[data-v-bfd41fd6] {\n  position: relative;\n  height: 0;\n  padding-bottom: 56.25%;\n  overflow: hidden;\n}\n.video-block > div iframe[data-v-bfd41fd6] {\n    border: none;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 104:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(100);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(56)("37343bec", content, true);

/***/ }),

/***/ 114:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-block"
  }, [_c('div', [_c('iframe', {
    ref: "videoFrame",
    staticClass: "fullfill",
    attrs: {
      "src": _vm.sourceLink,
      "webkitallowfullscreen": "webkitallowfullscreen",
      "mozallowfullscreen": "mozallowfullscreen",
      "allowfullscreen": "allowfullscreen"
    }
  })])])
},staticRenderFns: []}

/***/ }),

/***/ 135:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'modal',
    data: function data() {
        return { opened: false };
    },

    methods: {
        open: function open() {
            this.opened = true;
            this.$emit('opened');
        },
        close: function close() {
            this.opened = false;
            this.$emit('closed');
        }
    }
});

/***/ }),

/***/ 139:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__templates_Page_vue__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__templates_Page_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__templates_Page_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_modals_Modal_vue__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_modals_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_modals_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_blocks_VideoBlock_vue__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_blocks_VideoBlock_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_blocks_VideoBlock_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'main-page',
    extends: __WEBPACK_IMPORTED_MODULE_0__templates_Page_vue___default.a,
    metaInfo: function metaInfo() {
        var title = "Sota. " + this.$t('$meta.main.title') + ".";
        var description = this.pageInfo.phrase ? this.pageInfo.phrase[this.$i18n.locale] : "";
        return {
            title: title,
            titleTemplate: null,
            meta: [{ property: "og:title", content: title }, { property: "og:description", content: description }, { property: "og:video", content: this.pageInfo.showreel }, { property: "og:url", content: this.$router.fullPath }, { name: "twitter:title", content: title }, { name: "twitter:description", content: description }]
        };
    },
    data: function data() {
        return {
            showVideo: window.innerWidth > 768,
            pageInfo: {},
            video: {
                width: null,
                height: null,
                left: null,
                top: null
            }
        };
    },
    created: function created() {
        var _this = this;

        if (window.innerWidth <= 768) {
            this.showVideo = false;
        }
        this.resizeVideo();
        window.onresize = this.resizeVideo;
        this.$emit("init", "white", false);
        this.$http.get("pages/main").then(function (response) {
            _this.pageInfo = response.body;
            _this.$emit("end-loading");
        });
    },

    computed: {
        videoCss: function videoCss() {
            var style = "";
            if (this.video.width) style += "width: " + this.video.width + "px;";
            if (this.video.height) style += "height: " + this.video.height + "px;";
            if (this.video.left) style += "left: " + this.video.left + "px;";
            if (this.video.top) style += "top: " + this.video.top + "px;";
            return style;
        }
    },
    destroyed: function destroyed() {
        window.onresize = null;
    },

    methods: {
        resizeVideo: function resizeVideo() {
            console.log("resize");
            this.video = {};
            if (window.innerWidth / window.innerHeight > 16 / 9) {
                this.video.width = window.innerWidth;
                this.video.top = -(this.video.width / 16 * 9 - window.innerHeight) / 2;
            } else {
                this.video.height = window.innerHeight;
                this.video.left = -(this.video.height / 9 * 16 - window.innerWidth) / 2;
            }
        },

        playBackgroundVideo: function playBackgroundVideo() {
            this.$refs.backgroundVideo.play();
            this.$refs.showreelVideo.pause();
        },
        pauseBackgroundVideo: function pauseBackgroundVideo() {
            this.$refs.backgroundVideo.pause();
            this.$refs.showreelVideo.play();
        }
    },
    components: {
        'modal': __WEBPACK_IMPORTED_MODULE_1__components_modals_Modal_vue___default.a,
        'video-block': __WEBPACK_IMPORTED_MODULE_2__components_blocks_VideoBlock_vue___default.a
    }
});

/***/ }),

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(55)(true);
// imports


// module
exports.push([module.i, ".modal[data-v-4ee0041a]{z-index:2000;background-color:rgba(0,0,0,.6);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.modal .modal-content[data-v-4ee0041a]{position:relative}", "", {"version":3,"sources":["D:/Relocus/Dev/_Archive/Sota/sota/src/components/modals/Modal.vue"],"names":[],"mappings":"AACA,wBACE,aAAc,AACd,gCAAqC,AACrC,yBAA0B,AAE1B,sBAAuB,AAEvB,qBAAsB,AAEtB,gBAAkB,CACnB,AACD,uCACI,iBAAmB,CACtB","file":"Modal.vue","sourcesContent":["\n.modal[data-v-4ee0041a] {\n  z-index: 2000;\n  background-color: rgba(0, 0, 0, 0.6);\n  -webkit-user-select: none;\n  /* Chrome all / Safari all */\n  -moz-user-select: none;\n  /* Firefox all */\n  -ms-user-select: none;\n  /* IE 10+ */\n  user-select: none;\n}\n.modal .modal-content[data-v-4ee0041a] {\n    position: relative;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(55)(true);
// imports


// module
exports.push([module.i, "#main{position:static}#main .background{background-color:#000}#main .video-modal{padding-top:70px}#main .video-modal .container{max-width:1040px}@media (max-width:577px){#main .video-modal .container{padding:0}}#main .content .container{margin-top:-15px;max-width:1100px}@media (min-width:993px){#main .content .container{padding-left:25px;padding-right:25px}}#main .content h1{margin:0;color:#fff}@media (max-width:769px){#main .content h1{font-size:60px;line-height:.9;letter-spacing:-1.2px}}@media (max-height:450px),(max-width:577px){#main .content h1{font-size:45px;line-height:.89;letter-spacing:-.9px}}#main .content .showreel-link{position:absolute;bottom:100px;left:0;right:0}#main .content .showreel-link .action{color:#fff}@media (max-height:450px){#main .content .showreel-link{bottom:40px}}#main .background{position:fixed}#main .background .overlay{z-index:3;background:#000;opacity:.4}#main .background .background-video{z-index:2;min-width:100%;min-height:100%;position:absolute}#main .background .background-image{z-index:1;min-width:100%;min-height:100%;position:relative;background-size:cover;background-position:50%}", "", {"version":3,"sources":["D:/Relocus/Dev/_Archive/Sota/sota/src/pages/Main.vue"],"names":[],"mappings":"AACA,MACE,eAAiB,CAClB,AACD,kBACI,qBAAwB,CAC3B,AACD,mBACI,gBAAkB,CACrB,AACD,8BACM,gBAAkB,CACvB,AACD,yBACA,8BACU,SAAW,CACpB,CACA,AACD,0BACI,iBAAkB,AAClB,gBAAkB,CACrB,AACD,yBACA,0BACQ,kBAAmB,AACnB,kBAAoB,CAC3B,CACA,AACD,kBACI,SAAU,AACV,UAAe,CAClB,AACD,yBACA,kBACQ,eAAgB,AAChB,eAAkB,AAClB,qBAAuB,CAC9B,CACA,AACD,4CACA,kBACQ,eAAgB,AAChB,gBAAkB,AAClB,oBAAuB,CAC9B,CACA,AACD,8BACI,kBAAmB,AACnB,aAAc,AACd,OAAQ,AACR,OAAS,CACZ,AACD,sCACM,UAAa,CAClB,AACD,0BACA,8BACQ,WAAa,CACpB,CACA,AACD,kBACI,cAAgB,CACnB,AACD,2BACM,UAAW,AACX,gBAAkB,AAClB,UAAa,CAClB,AACD,oCACM,UAAW,AACX,eAAgB,AAChB,gBAAiB,AACjB,iBAAmB,CACxB,AACD,oCACM,UAAW,AACX,eAAgB,AAChB,gBAAiB,AACjB,kBAAmB,AACnB,sBAAuB,AACvB,uBAAmC,CACxC","file":"Main.vue","sourcesContent":["\n#main {\n  position: static;\n}\n#main .background {\n    background-color: black;\n}\n#main .video-modal {\n    padding-top: 70px;\n}\n#main .video-modal .container {\n      max-width: 1040px;\n}\n@media (max-width: 577px) {\n#main .video-modal .container {\n          padding: 0;\n}\n}\n#main .content .container {\n    margin-top: -15px;\n    max-width: 1100px;\n}\n@media (min-width: 993px) {\n#main .content .container {\n        padding-left: 25px;\n        padding-right: 25px;\n}\n}\n#main .content h1 {\n    margin: 0;\n    color: #ffffff;\n}\n@media (max-width: 769px) {\n#main .content h1 {\n        font-size: 60px;\n        line-height: 0.90;\n        letter-spacing: -1.2px;\n}\n}\n@media (max-width: 577px), (max-height: 450px) {\n#main .content h1 {\n        font-size: 45px;\n        line-height: 0.89;\n        letter-spacing: -0.9px;\n}\n}\n#main .content .showreel-link {\n    position: absolute;\n    bottom: 100px;\n    left: 0;\n    right: 0;\n}\n#main .content .showreel-link .action {\n      color: white;\n}\n@media (max-height: 450px) {\n#main .content .showreel-link {\n        bottom: 40px;\n}\n}\n#main .background {\n    position: fixed;\n}\n#main .background .overlay {\n      z-index: 3;\n      background: black;\n      opacity: 0.4;\n}\n#main .background .background-video {\n      z-index: 2;\n      min-width: 100%;\n      min-height: 100%;\n      position: absolute;\n}\n#main .background .background-image {\n      z-index: 1;\n      min-width: 100%;\n      min-height: 100%;\n      position: relative;\n      background-size: cover;\n      background-position: center center;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 158:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(148);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(56)("163a233e", content, true);

/***/ }),

/***/ 160:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(150);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(56)("015dac3f", content, true);

/***/ }),

/***/ 166:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(158)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(135),
  /* template */
  __webpack_require__(173),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4ee0041a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 173:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.opened),
      expression: "opened"
    }],
    staticClass: "modal fullfill table",
    on: {
      "click": _vm.close
    }
  }, [_c('div', {
    staticClass: "modal-content table-cell"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._t("default")], 2)])])
},staticRenderFns: []}

/***/ }),

/***/ 175:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "main"
    }
  }, [_c('div', {
    staticClass: "background fullfill"
  }, [_c('div', {
    staticClass: "overlay fullfill"
  }), (_vm.pageInfo.background && _vm.pageInfo.background.video && _vm.showVideo) ? _c('video', {
    ref: "backgroundVideo",
    staticClass: "background-video",
    style: (_vm.videoCss),
    attrs: {
      "autoplay": "autoplay",
      "loop": "loop",
      "plays-inline": "plays-inline"
    },
    domProps: {
      "muted": true
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.pageInfo.background.video,
      "type": "video/mp4"
    }
  })]) : _vm._e(), (_vm.pageInfo.background && _vm.pageInfo.background.image && !_vm.showVideo) ? _c('div', {
    staticClass: "background-image",
    style: ('background-image: url(' + _vm.pageInfo.background.image + _vm.getOptimalImageSize('crop', 'fullwidth', null) + ')')
  }) : _vm._e()]), _c('div', {
    staticClass: "content fullfill table"
  }, [_c('div', {
    staticClass: "table-cell"
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.pageInfo.phrase) ? _c('h1', {
    staticClass: "head"
  }, [_vm._v(_vm._s(_vm.pageInfo.phrase[_vm.$i18n.locale]))]) : _vm._e()])]), (_vm.pageInfo.showreel) ? _c('div', {
    staticClass: "showreel-link"
  }, [_c('a', {
    staticClass: "grey action",
    on: {
      "click": function($event) {
        _vm.$refs.modal.open()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('$buttons.showreel')))])]) : _vm._e()]), _c('modal', {
    ref: "modal",
    staticClass: "video-modal",
    on: {
      "opened": _vm.pauseBackgroundVideo,
      "closed": _vm.playBackgroundVideo
    }
  }, [(_vm.pageInfo.showreel) ? _c('video-block', {
    ref: "showreelVideo",
    attrs: {
      "content": _vm.pageInfo.showreel
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 60:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(160)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(139),
  /* template */
  __webpack_require__(175),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 64:
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ 65:
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(68)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(86),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 67:
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.0' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ 68:
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ 69:
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ 70:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);


/* harmony default export */ __webpack_exports__["default"] = ({
    methods: {
        getOptimalImageSize: function getOptimalImageSize(type, width, height) {
            var maxWidth = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1170;

            var string = "?";
            var pixelDensity = Math.min(window.devicePixelRatio, 2);
            if (type == "crop" || type == "resize") string += type;else string += "resize";
            string += "&w=";
            if (width == "fullwidth") {
                var optimalWidth = maxWidth;
                if (window.innerWidth < optimalWidth) optimalWidth = optimalWidth - 70 * Math.floor((optimalWidth - window.innerWidth) / 70);
                string += Math.floor(optimalWidth * pixelDensity);
            } else if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(width)) {
                string += Math.floor(width * pixelDensity);
            } else {
                string += "-";
            }
            string += "&h=";
            if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(height)) {
                string += Math.floor(height * pixelDensity);
            } else {
                string += "-";
            }
            return string;
        },
        getStandartMeta: function getStandartMeta(name) {
            var title = this.$t('$meta.' + name + '.title');
            return {
                title: title,
                meta: [{ property: "og:title", content: title }, { property: "og:url", content: this.$router.fullPath }, { name: "twitter:title", content: title }]
            };
        }
    }
});

/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(72), __esModule: true };

/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(84);
module.exports = __webpack_require__(67).Number.isInteger;


/***/ }),

/***/ 73:
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ 74:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(64);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(73);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(64);
var document = __webpack_require__(69).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(69);
var core = __webpack_require__(67);
var ctx = __webpack_require__(75);
var hide = __webpack_require__(78);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && key in exports) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(81);
var createDesc = __webpack_require__(82);
module.exports = __webpack_require__(65) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(65) && !__webpack_require__(68)(function () {
  return Object.defineProperty(__webpack_require__(76)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ 80:
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(64);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),

/***/ 81:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(74);
var IE8_DOM_DEFINE = __webpack_require__(79);
var toPrimitive = __webpack_require__(83);
var dP = Object.defineProperty;

exports.f = __webpack_require__(65) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ 82:
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ 83:
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(64);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ 84:
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(77);

$export($export.S, 'Number', { isInteger: __webpack_require__(80) });


/***/ }),

/***/ 85:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(70),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 86:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        'content': {
            required: true
        }
    }
});

/***/ }),

/***/ 90:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(104)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(114),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-bfd41fd6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 95:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Block_vue__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Block_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Block_vue__);
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'video-block',
    extends: __WEBPACK_IMPORTED_MODULE_0__Block_vue___default.a,
    data: function data() {
        return { player: null };
    },
    mounted: function mounted() {
        console.log(this.sourceLink);
        if (this.hosting == "youtube") this.player = new YT.Player(this.$refs.videoFrame);
        if (this.hosting == "vimeo") this.player = new Vimeo.Player(this.$refs.videoFrame);
    },

    computed: {
        hosting: function hosting() {
            if (this.content.indexOf('youtube#') !== -1) return "youtube";
            if (this.content.indexOf('vimeo#') !== -1) return "vimeo";
            return null;
        },
        sourceId: function sourceId() {
            var res = this.content.split("#");
            return res.length > 1 ? res[1] : "";
        },
        sourceLink: function sourceLink() {
            if (this.hosting == "youtube") return "http://www.youtube.com/embed/" + this.sourceId + "?enablejsapi=1";
            if (this.hosting == "vimeo") return "https://player.vimeo.com/video/" + this.sourceId + "?title=0&byline=0&portrait=0";
            return "";
        }
    },
    methods: {
        pause: function pause() {
            this.$emit('pause');
            if (this.hosting == "youtube") this.player.pauseVideo();
            if (this.hosting == "vimeo") this.player.pause();
        },
        play: function play() {
            this.$emit('play');
            if (this.hosting == "youtube") this.player.playVideo();
            if (this.hosting == "vimeo") this.player.play();
        }
    }
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/4.4e6f9120db85960b1ab5.js